import { Marker } from 'react-leaflet';
import L from 'leaflet';

/**
 * Component to display a label for a range ring
 * Positions the label at the bottom (6 o'clock / south) of the ring
 */
function RangeRingLabel({ center, radius, label }) {
  // Calculate the position for the label at the bottom of the circle
  // We'll place it at the south point of the ring (6 o'clock position)

  // Earth's radius in meters
  const EARTH_RADIUS = 6378137;

  // Calculate the latitude offset
  // Moving south: subtract from latitude
  const latOffset = (radius / EARTH_RADIUS) * (180 / Math.PI);
  const labelPosition = [center[0] - latOffset, center[1]];

  // Create a custom icon for the label
  const labelIcon = L.divIcon({
    className: 'range-ring-label',
    html: `
      <div style="
        font-size: 11px;
        font-weight: bold;
        color: #666;
        background: transparent;
        padding: 3px 6px;
        white-space: nowrap;
      ">
        ${label}
      </div>
    `,
    iconSize: [0, 0],
    iconAnchor: [0, -8], // Center the label horizontally, position below the point
  });

  return (
    <Marker
      position={labelPosition}
      icon={labelIcon}
      interactive={false}
      pane="shadowPane"
    />
  );
}

export default RangeRingLabel;
